//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import AttestationCertification from '@/components/member/order-dialog/AttestationCertification.vue';
import QuestionList from '@/components/member/order-dialog/questionList.vue';
import { getQuestionList, getQuestion } from '@/api';
import { getRealNameAuthentication } from '@/api/member';

export default {
  components: {
    AttestationCertification,
    QuestionList,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const questionId = this.$config.AttestationQuestionId;
    return {
      dayjs,
      questionId,
      questionList: [],
      realNameStatus: null,
      questionDetail: null,
      resObj: {
        type: null,
        desc: null,
        expireTimestamp: null,
        id: null,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['kyc']),
    /**
     * @description 当前页面值
     */
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  async mounted() {
    await this.getQuestionDetail();
    this.getRealName();
    this.getList();
  },
  methods: {
    handleSuccess(type) {
      if (type === 'OTHER') {
        this.model = 5;
      } else {
        this.changePage();
      }
    },
    async getQuestionDetail() {
      const data = await this.$axios(getQuestion(this.questionId));
      this.questionDetail = data.result;
    },
    /**
     * @description 修改展示页
     */
    changePage() {
      const nowTime = new Date().getTime();
      if (
        this.model === 0 &&
        (this.kyc.certification || this.realNameStatus === 1)
      ) {
        if (
          this.questionDetail &&
          nowTime < this.questionDetail.expireTimestamp * 1000
        ) {
          const { expireTimestamp, description, evaluationType, id } =
            this.questionDetail;
          this.resObj = {
            type: evaluationType,
            desc: description,
            expireTimestamp,
            id,
          };
          this.model = 4;
        } else {
          this.model = 2;
        }
      } else if (this.model === 0 && this.realNameStatus === 2) {
        this.model = 5;
      } else if (this.model === 4) {
        this.$emit('attestationSuccess', this.resObj.id);
      } else if (
        this.model === 2 &&
        this.questionDetail &&
        nowTime < this.questionDetail.expireTimestamp * 1000
      ) {
        const { expireTimestamp, description, evaluationType, id } =
          this.questionDetail;
        this.resObj = {
          type: evaluationType,
          desc: description,
          expireTimestamp,
          id,
        };
        this.model = 4;
      } else {
        this.model++;
      }
    },
    /**
     * @description 获取问卷列表
     */
    async getList() {
      const data = await this.$axios(getQuestionList(this.questionId));
      if (data.result) {
        let arr = data.result.questions || [];
        arr = arr.map(item => {
          return {
            ...item,
            answer: null,
          };
        });
        this.questionList = arr;
      }
    },
    async getRealName() {
      const data = await this.$axios(getRealNameAuthentication());
      if (data.result) {
        this.realNameStatus = data.result.status;
      }
    },
  },
};
